class VariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this.selectors = this.querySelectorAll("input[type='radio']");
    this.handleChange = this.handleChange.bind(this);

    this.selectors.forEach((selector) => {
      selector.addEventListener("change", this.handleChange);
    });
  }

  disconnectedCallback() {
    this.selectors.forEach((selector) => {
      selector.removeEventListener("change", this.handleChange);
    });
  }

  handleChange(event) {
    const url = `${window.location.pathname}?variant=${event.currentTarget.value}&section_id=${this.sectionId}`;

    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data;
        document.querySelector(".pdp-information").innerHTML =
          tempDiv.querySelector(".pdp-information").innerHTML;
        // document.querySelector(".pdp-gallery").innerHTML =
        //   tempDiv.querySelector(".pdp-gallery").innerHTML;

        const newUrl = new URL(url, window.location.origin);
        newUrl.searchParams.delete("section_id");
        window.history.pushState({}, "", newUrl.toString());

        // Dispatch event to notify components have been updated
        document.dispatchEvent(new CustomEvent("variant:updated"));
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Error fetching variant:", error);
        }
      });
  }
}

customElements.define("variant-selector", VariantSelector);
